const countFittingOnLine = ({
  availableWidth,
  filterWidths,
  toggleWidth,
  gap,
}: {
  availableWidth: number;
  filterWidths: number[];
  toggleWidth: number;
  gap: number;
}): number => {
  const widthOfAll =
    filterWidths.reduce((sum, width) => sum + width, 0) +
    gap * Math.max(filterWidths.length - 1, 0);

  if (widthOfAll <= availableWidth) {
    return filterWidths.length;
  }

  let usedWidth = toggleWidth;
  let count = 0;

  for (let index = filterWidths.length - 1; index >= 0; index--) {
    usedWidth += filterWidths[index] + gap;

    if (usedWidth > availableWidth) {
      break;
    }

    count++;
  }

  return count;
};

/**
 * Returns how many filters to show when collapsed, counting back from the most
 * recently added (the end of `filterWidths`). If every filter fits, the expand
 * toggle isn't needed; otherwise its width is reserved.
 *
 * Filters prefer the line after the leading content. If none fit there, they
 * get a full line of their own, and the most recent filter is always shown.
 */
export const countFittingFilters = ({
  rowWidth,
  leadingWidth,
  filterWidths,
  toggleWidth,
  gap,
}: {
  rowWidth: number;
  leadingWidth: number;
  filterWidths: number[];
  toggleWidth: number;
  gap: number;
}): number => {
  if (filterWidths.length === 0) {
    return 0;
  }

  const afterLeading = countFittingOnLine({
    availableWidth: rowWidth - leadingWidth - gap,
    filterWidths,
    toggleWidth,
    gap,
  });

  if (afterLeading > 0) {
    return afterLeading;
  }

  return Math.max(
    countFittingOnLine({
      availableWidth: rowWidth,
      filterWidths,
      toggleWidth,
      gap,
    }),
    1,
  );
};
